import { Component } from '@angular/core';
import { NavController, IonicPage } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController) {

  }

  goBaiduMap() {
    this.navCtrl.push('BaiduMapPage');
  }
 
  goGaodeMap() {
    this.navCtrl.push('GapdeMapPage');
  }

  testMap() {
    this.navCtrl.push('TestMapPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts